/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { AccountsQuery } from "@/app/types/generated/graphql";

type AccountsHeaders = "Membership ID" | "Membership Type" | "Authorised User Email" | "Member Name" | "Status";

const getAccountData = (accountSummary: AccountsQuery["accounts"][0]): Record<AccountsHeaders, string> => {
  return {
    "Membership ID": accountSummary.members?.[0].membershipId ?? "",
    "Membership Type": accountSummary.members?.[0].membershipType ?? "",
    "Authorised User Email": accountSummary.email,
    "Member Name": accountSummary.members?.[0].name ?? "",
    Status: accountSummary.status,
  };
};

export const createAccountsDataForCSV = (accounts: AccountsQuery["accounts"]) => {
  return accounts.map((account) => getAccountData(account));
};
